import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth-context";

const Auth = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const { from = "/dashboard" } = state || {};
  const { refreshSession } = useAuth();

  // OAuth (Google/Apple) callback landing page. The backend sets the session cookie on the
  // callback, so there is nothing to read out of the URL any more — we just confirm the
  // session exists and move on. The legacy `?session=<jwt>` param is deliberately ignored;
  // a JWT in a URL ends up in browser history, Referer headers and analytics.
  useEffect(() => {
    let cancelled = false;

    const confirm = async () => {
      const ok = await refreshSession();
      if (cancelled) return;
      navigate(ok ? from : "/login", { replace: true });
    };

    confirm();

    return () => {
      cancelled = true;
    };
  }, [refreshSession, navigate, from]);

  return (
    <div className="w-full h-screen flex justify-center items-center bg-gray-50 dark:bg-primary_dark_light">
      <div className="flex flex-col items-center justify-center text-center p-8 bg-white dark:bg-primary_dark rounded-lg shadow-xl">
        <svg
          className="h-16 w-16 text-blue-600"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
            stroke="#095B97"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m9 12 2 2 4-4"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <animate
              attributeName="stroke-dasharray"
              from="0 10"
              to="10 10"
              dur="0.5s"
              begin="0.5s"
              fill="freeze"
            />
            <animate
              attributeName="stroke-dashoffset"
              from="10"
              to="0"
              dur="0.5s"
              begin="0.5s"
              fill="freeze"
            />
          </path>
          <style>
            {`
                path:first-of-type {
                  animation: fill-shield 0.5s ease-in forwards;
                }
                @keyframes fill-shield {
                  from { fill: transparent; }
                  to { fill: #095B97; }
                }
              `}
          </style>
        </svg>
        <h2 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">
          Authenticating...
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Please wait while we verify your session. You'll be redirected
          shortly.
        </p>
      </div>
    </div>
  );
};

export default Auth;
